module.exports = __webpack_public_path__ + "static/media/ShareUniversalActive.72fc2b57.png";